import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonList } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import isEqual from 'lodash/isEqual';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { analytics } from 'app/utils/segment';
import styles from '../menu.module.scss';
export const Item = memo(function Item({ item, isItemActive, setActiveItem, }) {
    const { segmentId, icon, route, title } = item;
    const navigate = useNavigate();
    const classNames = classnames(styles.menuItem, styles.menuItemControl, {
        [styles.activeButton]: isItemActive,
    });
    function handleClick() {
        setActiveItem(item);
        navigate(route);
        analytics.settingsMenuItemClicked({ id: segmentId });
    }
    return (_jsx(ButtonList.Item, Object.assign({ "data-testid": `menu-item-${segmentId}`, onClick: handleClick, buttonClassName: classNames, icon: icon }, { children: title })));
}, isEqual);
Item.displayName = 'SettingsMenuMenuItem';
